import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../Utils/Function';
import { FaSpinner, FaSearch, FaFingerprint } from 'react-icons/fa';

const AdminUsers = () => {
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [activeTab, setActiveTab] = useState('clients');

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(`${BASE_URL}/users/getUser.php`);
            if (response.data.status === 200) {
                // Sort by ID descending (Latest first)
                const sorted = [...response.data.data].sort((a, b) =>
                    parseInt(b.user_id) - parseInt(a.user_id)
                );
                setUsers(sorted);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setIsLoading(false);
        }
    };


    const filteredUsers = users.filter(user =>
        user.user_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.mobile_no?.includes(searchTerm)
    );

    const role1Users = filteredUsers.filter(user => user.role === '1' || user.role === 1);
    const role2Users = filteredUsers.filter(user => user.role === '2' || user.role === 2);

    return (
        <div className="admin-users-page px-4">
            <div className="d-flex justify-content-between align-items-end mb-5">
                <div>
                    <span className="section-index">DATABASE</span>
                    <h2 className="display-6 text-white text-uppercase m-0" style={{ letterSpacing: '3px' }}>User Repository</h2>
                </div>
                <div className="search-wrap position-relative">
                    <FaSearch className="search-icon" />
                    <input
                        type="text"
                        className="admin-search-input"
                        placeholder="Search users by name or mobile..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            {isLoading ? (
                <div className="text-center py-5 mt-5">
                    <FaSpinner className="spinner mb-3" style={{ fontSize: '2rem', color: 'var(--secondary-color)' }} />
                    <p className="text-white-50 letter-spacing-2">ACCESSING USER CORE...</p>
                </div>
            ) : (
                <div className="dashboard-panel">
                    {/* Tabs */}
                    <div className="d-flex gap-4 mb-4 border-bottom border-white-10 pb-3">
                        <button
                            className={`tab-btn ${activeTab === 'clients' ? 'active' : ''}`}
                            onClick={() => setActiveTab('clients')}
                        >
                            CLIENT DATABASE
                            <span className="badge-count">{role1Users.length}</span>
                        </button>
                        <button
                            className={`tab-btn tab-admin ${activeTab === 'admins' ? 'active' : ''}`}
                            onClick={() => setActiveTab('admins')}
                        >
                            SYSTEM ADMINISTRATORS
                            <span className="badge-count">{role2Users.length}</span>
                        </button>
                    </div>

                    {/* Role 1 Table: Clients */}
                    {activeTab === 'clients' && (
                        <div className="table-wrapper fade-in">
                            <table className="admin-table-custom">
                                <thead>
                                    <tr>
                                        <th>INITIAL</th>
                                        <th>CLIENT IDENTITY</th>
                                        <th>MOBILE PORT</th>
                                        <th>ENTRY DATE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {role1Users.map((user) => (
                                        <tr key={user.user_id}>
                                            <td>
                                                <div className="user-avatar-mini">
                                                    {(user.user_name || 'U').charAt(0).toUpperCase()}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="text-white fw-500">{user.user_name}</div>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    <FaFingerprint size={12} className="text-secondary-dim" />
                                                    <span className="text-white-50">{user.mobile_no}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="text-white-50">{new Date(user.created_at || Date.now()).toLocaleDateString()}</div>
                                            </td>
                                        </tr>
                                    ))}
                                    {role1Users.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-center py-4">
                                                <h5 className="text-white-50 letter-spacing-2 m-0 fs-07">NO CLIENT RECORDS FOUND</h5>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Role 2 Table: Admins */}
                    {activeTab === 'admins' && (
                        <div className="table-wrapper fade-in">
                            <table className="admin-table-custom">
                                <thead>
                                    <tr>
                                        <th>INITIAL</th>
                                        <th>ADMIN IDENTITY</th>
                                        <th>MOBILE PORT</th>
                                        <th>ENTRY DATE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {role2Users.map((user) => (
                                        <tr key={user.user_id}>
                                            <td>
                                                <div className="user-avatar-mini" style={{ borderColor: 'rgba(220, 53, 69, 0.3)', color: '#dc3545', background: 'rgba(220, 53, 69, 0.05)' }}>
                                                    {(user.user_name || 'A').charAt(0).toUpperCase()}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="text-white fw-500">{user.user_name}</div>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    <FaFingerprint size={12} className="text-danger-dim" style={{ opacity: 0.7 }} />
                                                    <span className="text-white-50">{user.mobile_no}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="text-white-50">{new Date(user.created_at || Date.now()).toLocaleDateString()}</div>
                                            </td>
                                        </tr>
                                    ))}
                                    {role2Users.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-center py-4">
                                                <h5 className="text-white-50 letter-spacing-2 m-0 fs-07">NO ADMIN RECORDS FOUND</h5>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}


            <style>{`
                .admin-search-input {
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.1);
                    color: white;
                    padding: 12px 20px 12px 45px;
                    border-radius: 2px;
                    font-size: 0.8rem;
                    width: 350px;
                    outline: none;
                    transition: all 0.3s ease;
                }
                .admin-search-input:focus { border-color: var(--secondary-color); background: rgba(255,255,255,0.05); }
                
                .search-icon {
                    position: absolute;
                    left: 20px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: rgba(255,255,255,0.3);
                    font-size: 0.9rem;
                }

                .dashboard-panel {
                    background: rgba(10, 10, 10, 0.4);
                    backdrop-filter: blur(20px);
                    border: 1px solid rgba(255, 255, 255, 0.05);
                    padding: 30px;
                    border-radius: 4px;
                }

                .admin-table-custom {
                    width: 100%;
                    border-collapse: separate;
                    border-spacing: 0 8px;
                }

                .admin-table-custom th {
                    color: var(--secondary-color);
                    font-size: 0.65rem;
                    letter-spacing: 2px;
                    font-weight: 600;
                    padding: 15px 20px;
                    text-transform: uppercase;
                    border-bottom: 1px solid rgba(255,255,255,0.05);
                }

                .admin-table-custom tbody tr {
                    background: rgba(255, 255, 255, 0.02);
                    transition: all 0.3s ease;
                }

                .admin-table-custom tbody tr:hover {
                    background: rgba(255, 255, 255, 0.04);
                    transform: translateX(5px);
                }

                .admin-table-custom td {
                    padding: 15px 20px;
                    font-size: 0.8rem;
                    vertical-align: middle;
                }

                .user-avatar-mini {
                    width: 35px;
                    height: 35px;
                    border: 1px solid rgba(197, 160, 89, 0.3);
                    color: var(--secondary-color);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.9rem;
                    border-radius: 2px;
                    background: rgba(197, 160, 89, 0.05);
                }

                .text-secondary-dim { color: var(--secondary-color); opacity: 0.5; }
                .fs-07 { font-size: 0.7rem; }

                .btn-purge-mini {
                    background: rgba(220, 53, 69, 0.1);
                    border: 1px solid rgba(220, 53, 69, 0.2);
                    color: #dc3545;
                    width: 35px;
                    height: 35px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.3s ease;
                    border-radius: 2px;
                }

                .btn-purge-mini:hover { 
                    background: #dc3545; 
                    color: white; 
                    border-color: #dc3545; 
                    box-shadow: 0 0 15px rgba(220, 53, 69, 0.3);
                }

                .confirm-modal-compact { max-width: 380px; width: 100%; }

                .delete-glow-wrap {
                    width: 70px;
                    height: 70px;
                    background: rgba(220, 53, 69, 0.1);
                    color: #dc3545;
                    border: 1px solid rgba(220, 53, 69, 0.3);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto;
                    font-size: 2rem;
                    box-shadow: 0 0 30px rgba(220, 53, 69, 0.1);
                }

                @media (max-width: 768px) {
                    .admin-search-input { width: 100%; }
                    .search-wrap { width: 100%; margin-top: 20px; }
                    .d-flex.justify-content-between { flex-direction: column; align-items: flex-start !important; }
                }

                .tab-btn {
                    background: transparent;
                    border: none;
                    color: rgba(255, 255, 255, 0.4);
                    font-size: 0.75rem;
                    letter-spacing: 2px;
                    padding-bottom: 10px;
                    position: relative;
                    transition: all 0.3s ease;
                    text-transform: uppercase;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }

                .tab-btn:hover { color: white; }

                .tab-btn.active {
                    color: var(--secondary-color);
                    font-weight: 600;
                }

                .tab-btn.active::after {
                    content: '';
                    position: absolute;
                    bottom: -1px;
                    left: 0;
                    width: 100%;
                    height: 2px;
                    background: var(--secondary-color);
                    box-shadow: 0 -5px 10px rgba(197, 160, 89, 0.3);
                }

                .tab-btn.tab-admin.active { color: #dc3545; }
                .tab-btn.tab-admin.active::after { 
                    background: #dc3545; 
                    box-shadow: 0 -5px 10px rgba(220, 53, 69, 0.3);
                }

                .badge-count {
                    background: rgba(255, 255, 255, 0.1);
                    padding: 2px 8px;
                    border-radius: 2px;
                    font-size: 0.65rem;
                    color: white;
                }

                .tab-btn.active .badge-count {
                    background: var(--secondary-color);
                    color: black;
                }

                .tab-btn.tab-admin.active .badge-count {
                    background: #dc3545;
                    color: white;
                }

                .fade-in { animation: fadeIn 0.4s ease-out forwards; }
                
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                .border-white-10 { border-color: rgba(255,255,255,0.05) !important; }
            `}</style>
        </div>
    );
};

export default AdminUsers;
